var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      staticClass: "savewithsub",
      on: {
        click: function ($event) {
          return _vm.$emit("closesubinfo")
        },
      },
    }),
    _c("div", { staticClass: "submodal" }, [
      _c("h5", [_vm._v(_vm._s(_vm.$root.language.wsm_sub_info_popup_head))]),
      _c("span", {
        domProps: {
          innerHTML: _vm._s(_vm.$root.language.wsm_sub_info_popup_body),
        },
      }),
      _c("div", { staticClass: "btnContainer" }, [
        _c(
          "button",
          {
            on: {
              click: function ($event) {
                return _vm.$emit("closesubinfo")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$root.language.wsm_sub_closePopup))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }